import * as React from 'react';
import Header from '@mobileComponent/Header'
import { OpenApiDoMain } from '@src/constants'
import Bottom from '@mobileComponent/Bottom'
import { Link } from 'react-router-dom';
import './style.scss'
import * as moment from 'moment'
import axios from 'axios'

export interface INewsDetailProps {
  location: any,
  match: any
}

export default class NewsDetail extends React.Component<INewsDetailProps, any> {
  constructor(props: INewsDetailProps) {
    super(props);
    this.state = {
        item: ''
    }
}


  public componentDidMount() {
    const mobile = sessionStorage.getItem('mobile') === 'true' ? true : false
    if (!mobile) {
        location.href = '/detail/' + this.props.match.params.id
        return
    }
    
    // 接受路由传参
    const id = this.props.match.params.id
    const that = this
    axios.get(OpenApiDoMain + '/article/' + id)
      .then((res) => {
        that.setState({
          item: res.data.data
        });
      })
    scrollTo(0, 0)
  }

  public render() {
    return (
      <div className="news-detail">
        <Header />
        <div className="first-content-game">
          <div className="game-detail-title">{this.state.item.title}</div>
          <div className="game-detail-describe">{moment(this.state.item.createTime).format('YYYY-MM-DD')}</div>
        </div>
        <div className="content-nav"><Link to={{ pathname: `/mobileHome` }}>首页</Link> &gt; <Link to={{ pathname: `/mobileNews` }}>新闻资讯</Link> &gt; 新闻详情</div>
        <div className="content-navigation" dangerouslySetInnerHTML={{ __html: this.state.item.content }} />
        <Bottom />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Mobile/NewsDetail/index.tsx